// ============================================================================
// note-client-mod -- Note 注册器
//
// 1. 通过 DI 获取 IUserCenterSlotsService，注册 "my-notes" slot 到用户中心
// 2. 注册公开页面路由：
//    - /notes     — 公开笔记列表页
//    - /notes/:id — 公开笔记详情页
// 3. 使用 IFetchService 实现 SSR loader（后端直接调用服务，避免 Worker 死锁）
// ============================================================================
import { NotePanel } from './components/note-panel.js';
import { NoteListPage } from './pages/note-list-page.js';
import { NoteDetailPage } from './pages/note-detail-page.js';
import { setNoteApiClient } from './note-api-client.js';
import { NoteApiClient } from './note-api-client.js';
import { NoteIcon } from './components/icons.js';
/**
 * Note 客户端注册器
 */
export class NoteRegistrar {
    constructor(deps) {
        const { userCenterSlots, pageRouteRegistry, fetchService } = deps;
        // 0. 注入 fetchService 到全局 API 客户端单例（浏览器/SSR 环境自适应）
        setNoteApiClient(new NoteApiClient({ fetchService }));
        // 1. 注册 "我的笔记" slot 到用户中心（管理后台）
        userCenterSlots.registerSlot({
            id: 'my-notes',
            label: '我的笔记',
            icon: NoteIcon,
            component: NotePanel,
            order: 20,
            modName: 'note-client',
        });
        // 2. 注册公开笔记列表页（带 SSR loader）
        pageRouteRegistry.registerPage({
            path: '/notes',
            component: NoteListPage,
            key: 'note-list',
            meta: {
                title: '公开笔记',
            },
            modName: 'note-client',
            loader: async (args) => {
                const searchParams = new URLSearchParams();
                if (args.location.query) {
                    for (const [k, v] of Object.entries(args.location.query)) {
                        if (v != null)
                            searchParams.set(k, String(v));
                    }
                }
                const url = `/api/public/notes?${searchParams.toString()}`;
                const response = await fetchService.fetch(url, {
                    method: 'GET',
                    headers: args.request?.headers,
                });
                return response.json();
            },
        });
        // 3. 注册公开笔记详情页（带 SSR loader）
        pageRouteRegistry.registerPage({
            path: '/notes/:id',
            component: NoteDetailPage,
            key: 'note-detail',
            meta: {
                title: '笔记详情',
            },
            modName: 'note-client',
            loader: async (args) => {
                const id = args.params.id;
                const url = `/api/public/notes/${id}`;
                const response = await fetchService.fetch(url, {
                    method: 'GET',
                    headers: args.request?.headers,
                });
                return response.json();
            },
        });
    }
}
//# sourceMappingURL=note-registrar.js.map